import React, { useState } from 'react';
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  alpha,
  Avatar,
} from '@mui/material';
import ButtonComponent from 'src/components/shared/Button';
import theme from 'src/config/theme';
import {
  CardContainer,
  CardHeader,
  InnerContainer,
  ProfileContainer,
  Title,
  Year_Gender,
  Title2,
  Dot,
  Line,
  InnerContainer2,
  Title3,
  SymptomsContainer,
  SymptomsText,
  CheapContainer,
  MenuContainer,
  AvatarIcon,
  PatientCardContainer,
  PagingContainer,
  Container2,
  InnerAppointments,
  InnerBox
} from './Style';
import { ReactComponent as More } from '../../../../assets/images/more.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../../assets/images/slider-vertical.svg';
import { ReactComponent as Edit2 } from '../../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../assets/images/add-square.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as Danger } from '../../../../assets/images/danger.svg';
import { ReactComponent as Call } from '../../../../assets/images/call.svg';
import useResponsive from 'src/components/hooks/useResponsive';

import { useNavigate } from 'react-router-dom';
import Paging from 'src/components/App/Paging';

const SpotlightWrapper = ({ children }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return (
    <Box
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setOpacity(1)}
      onMouseLeave={() => setOpacity(0)}
      sx={{
        position: 'relative',
        borderRadius: '16px',
        overflow: 'hidden',
        background: theme.palette.gery.white,
        border: `1px solid ${alpha(theme.palette.gery.black, 0.08)}`,
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        cursor: 'pointer',
        height: '100%',
        '&:hover': {
          transform: 'translateY(-6px) scale(1.02)',
          boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
          borderColor: alpha(theme.palette.primary.main, 0.3),
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          pointerEvents: 'none',
          top: 0, left: 0, right: 0, bottom: 0,
          background: `radial-gradient(400px circle at ${position.x}px ${position.y}px, ${alpha(theme.palette.primary.main, 0.12)}, transparent 40%)`,
          opacity: opacity,
          transition: 'opacity 0.3s ease',
          zIndex: 1,
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 2, height: '100%' }}>
        {children}
      </Box>
    </Box>
  );
};

const PatientCard = ({ page, perPage, setPage, totalCount, data }) => {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(item);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const actions = [
    { label: 'View Profile', icon: <Profile />, onClick: () => navigate('/appointment/Patients') },
    { label: 'Attend Now', icon: <ArrowRight />, onClick: () => navigate('/Patients') },
    {
      label: 'Cancel',
      icon: (
        <Close width={isMobile || isTablet ? 18 : 24} height={isMobile || isTablet ? 18 : 24} />
      ),
      onClick: () => handleOpen(),
    },
  ];
  return (
    // <Box
    //   sx={{
    //     display: 'grid',
    //     gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    //     gap: '20px',
    //   }}
    // >
    <Container2>
      <InnerAppointments>
        <InnerBox isEmpty={data.length === 0}>
          {data.map((item, index) => {
            return (
              <Box key={index} sx={{ 
                animation: 'cardPopIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) both',
                animationDelay: `${index * 0.08}s`,
                '@keyframes cardPopIn': {
                  '0%': { opacity: 0, transform: 'translateY(30px) scale(0.95)' },
                  '100%': { opacity: 1, transform: 'translateY(0) scale(1)' }
                }
              }}>
                <SpotlightWrapper>
                  <PatientCardContainer sx={{ border: 'none', boxShadow: 'none', '&:hover': { transform: 'none', boxShadow: 'none' } }}>
                    <CardHeader sx={{ [theme.breakpoints.down('md')]: { padding: '20px' } }}>
                  <Avatar 
                    sx={{ 
                      width: '74px', 
                      height: '74px', 
                      borderRadius: '16px',
                      background: theme.palette.primary.light4,
                      color: theme.palette.primary.main,
                      fontSize: '24px',
                      fontWeight: 'bold'
                    }}
                  >
                    {item.avatarInitial}
                  </Avatar>
                  <InnerContainer>
                    <Title>{item.name}</Title>
                    <Year_Gender>
                      <Title2>{item.age}</Title2>
                      <Dot />
                      <Title2>{item.sex}</Title2>
                    </Year_Gender>
                    {/* <Title3>Contact No.</Title3> */}
                  </InnerContainer>
                </CardHeader>
                <Line />
                <InnerContainer2 sx={{ [theme.breakpoints.down('md')]: { padding: '0 20px' } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '200px', gap: '10px' }}>
                    <Call width={isMobile || isTablet ? 18 : 20} />
                    <Title sx={{}}> {item.contact}</Title>
                  </Box>
                  <MenuContainer
                    onClick={(event) => handleMenuOpen(event, item)}
                    isActive={selectedRow === item}
                    disabled={true}
                  >
                    <More />
                  </MenuContainer>
                </InnerContainer2>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  sx={{
                    '& .MuiPaper-root': {
                      width: '176px',
                      borderRadius: '12px',
                      padding: '4px 18px',
                      backgroundColor: 'red',
                      border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                      backgroundColor: theme.palette.gery.white,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '14px',
                    },
                  }}
                >
                  {actions.map((action, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        action.onClick(selectedRow);
                        handleMenuClose();
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        {action.icon} <Typography>{action.label}</Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Menu>
                </PatientCardContainer>
              </SpotlightWrapper>
            </Box>
            );
          })}
        </InnerBox>
        <PagingContainer>


          <Paging
            page={page}
            perPage={perPage}
            count={totalCount || 0}
            onChange={(newPage) => setPage(newPage)}
          />
        </PagingContainer>

      </InnerAppointments>
    </Container2>
  );
};

export default PatientCard;
